import { VirtualGiftSectionPersonalisation as PageVirtualGiftSectionPersonalisation } from '@web/components/page-components/VirtualGiftSection'
import { useVirtualGiftSection } from '@web/components/page-components/VirtualGiftSection/VirtualGiftSectionProvider'
import { useHttpClient } from 'apps/fe-donation/libs/hooks/useHttpClient'

const VirtualGiftSectionPersonalisation = () => {
  const context = useVirtualGiftSection()
  const httpClient = useHttpClient({ isRelativeUrl: true })

  return (
    <PageVirtualGiftSectionPersonalisation
      onFinalise={async () => {
        const imageUrls = context.items.map((item, index) => {
          const itemOptions =
            context.settings.styles?.options?.items?.[index] || context.settings.styles?.options?.items?.[0]

          return `/api/virtual-gift?${new URLSearchParams({
            item: JSON.stringify(itemOptions),
            giftValue: JSON.stringify(item),
            width: `${itemOptions.imageWidth || 600}`,
            height: `${itemOptions.imageHeight || 600}`,
          }).toString()}`
        })

        // Warm the CDN cache by fetching all images
        const warmCachePromises = imageUrls.map((url) => httpClient(url, { method: 'GET' }))
        await Promise.all(warmCachePromises)

        imageUrls.forEach((url, index) => {
          context.updateItemUrl(index, url)
        })

        return true
      }}
    />
  )
}

export default VirtualGiftSectionPersonalisation
